export default __webpack_public_path__ + "static/m-banh3-9b1758ec42b5211848cd46a01b862354.jpg";